import type { TechniqueEntry } from '../schema';

// review: the base doc's worked example line (the off-duty feeling and the pills) is exemplar
// material — it belongs in this entry's exemplars field once gold standards exist, never in the
// instructions Sona receives each time.
export const developDiscrepancy: TechniqueEntry = {
  key: 'develop_discrepancy',
  version: '0.1',
  name: 'Develop discrepancy',
  pillar: 'MI',
  serves:
    'Letting a change-oriented member feel the gap between what the use gives them and the life they said they want: often the same feeling reached two different ways.',
  method: [
    'Reflect back the exact goal they chose, in their own words, then explore the reasoning under it: what sits behind that goal, and why now.',
    'Then hold the two poles side by side, both in their own language (the feeling the use gives them and the feeling they said they want) and name plainly that one is borrowing from the other: the same feeling, reached two ways, one of them taking back what it lends.',
    'Compose the naming fresh from their two poles; the side-by-side shape is the technique, the sentence is built from their words. Then stop. The gap is theirs to sit with.',
  ],
  never: [
    'Do not argue the gap, resolve it, talk them out of it, or move toward fixing.',
    {
      constraint: 'Never use this banned reflective hedge.',
      phrase: 'it sounds like',
    },
    'Never at a moment of live craving.',
  ],
  requiresFirst: [
    {
      kind: 'conversation',
      clause:
        "Both poles vivid in the member's own words, however they surfaced, worked in earlier practices or volunteered in plain conversation: what the use gives them, and the life they want. (Typically produced by function_of_use_descent and desired_state_elicitation; the evidence is the requirement, the techniques are not.)",
    },
    {
      kind: 'conversation',
      clause:
        'Only when their goal is change-oriented ("stop completely" / "cut back"); for exploratory goals (understand patterns / figuring out / not sure) this technique is ineligible: stay open, no gap.',
    },
  ],
  doneWhen:
    'The gap named plainly, in their language, and left with them: no argument, no plan, no resolution.',
  firstMove: null,
  exemplars: [],
  appliesTo: ['base', 'journey'],
  programs: null,
  signature: null,
  source:
    'shared/sections/practice_objective.md (Movement C), welcome_objective.md (discrepancy held back in conversation 1), base doc catalogue table',
};
